/* eslint-disable import/no-cycle */
import { createI18n } from 'vue-i18n';
import { USER_SETTINGS } from '@/configs/i18n-constants';
import { ENVIRONMENTS } from '@/data/environments';
import messages from '@/lang/';
import { ENV } from '../../config/app-env';

const i18n = createI18n({
  locale: USER_SETTINGS.LANG ?? USER_SETTINGS.FALLBACK_LANG,
  fallbackLocale: USER_SETTINGS.FALLBACK_LANG || 'en-us',
  messages,
  silentTranslationWarn: [ENVIRONMENTS.PRODUCTION, ENVIRONMENTS.TEST].includes(
    ENV.CLEARBANC_ENV,
  ),
});

// Aliasing for compatibility
i18n.t = function (...args: any) {
  return i18n.global.t(...args);
};

i18n.tc = function (...args: any) {
  return i18n.global.tc(...args);
};

// Check if the content exists
i18n.te = function (...args: any) {
  return i18n.global.te(...args);
};

export default i18n;
